const keys = {
    UserNameOauth: 'UserNameOauth',
    PasswordOauth: 'PasswordOauth',
    ClientId: 'client_id',
    BenefitId: 'benefitId',
    BaseUrlOauth: 'BaseUrlOauth',
    OauthUrl: 'OauthUrl',
    GeneralBenefit: 'generalBenefit',
    ePharmaCommonService: 'ePharma.Common.Service',
    EndpointCommonState: 'Endpoint.Common.StateRead',
    EndpointCommonCity: 'Endpoint.Common.City',
    EndpointCommonPrescriber: 'Endpoint.Common.Prescriber',
    ePharmaChainService: 'ePharma.Chain.Service',
    EndpointChainStore: 'Endpoint.Chain.Store',
    EndpointChainNeighborhood: 'Endpoint.Chain.Neighborhood',
    EndpointEurofarmaVerifyCoupon: 'Endpoint.Eurofarma.VerifyCoupon',
    EndpointEurofarmaVerifyEmployee: 'Endpoint.Eurofarma.VerifyEmployee',
    EndpointEurofarmaVerifyPerson: 'Endpoint.Eurofarma.VerifyPerson',
    EndPointEurofarmaBeneficiaryCupom: 'EndPoint.Beneficiary.Cupom',
    EndPointEurofarmaBeneficiaryCpf: 'EndPoint.Beneficiary.Cpf',
    EndpointEurofarmaGenerateCoupon: 'Endpoint.Eurofarma.GenerateCoupon',
    EndPointBeneficiaryEditCupom: 'EndPoint.Beneficiary.EditCupom',
    EndPointEurofarmaProduct: 'EndPoint.Product',
    EndPointEurofarmaSubProduct: 'EndPoint.SubProduct',
    ePharmaBeneficiaryService: 'ePharma.Beneficiary.Service',
    EndpointBeneficiaryBeneficiary: 'Endpoint.Beneficiary.Beneficiary',
    EndPointBeneficiaryFindBeneficiary: 'EndPoint.Beneficiary.FindBeneficiary',
    EndpointEurofarmaBenefit: 'Endpoint.Eurofarma.Benefit'
};

export default keys;